import QuestionObj from '../Models/QuestionObj';

const FieldService_QSet = [    
        new QuestionObj({
            questionSet:{
                English: 'Do field technicians have a 360-degree view of your customer, including account information, installed asset data, as well as order and service history?',
                German: 'German Q6',
                French: "French Q6",
                Russian: "Russian Q6",
                Turkish: "Turkish Q6",
                Italian: "Italian Q6",
                Spanish: "Spanish Q6",
                PortugueseBR: "PortugueseBR Q6",
                SpanishLAD: "SpanishLAD Q6",
             },
            answerSet:{
                English: [
                    'No, we are not able to deliver a full view of the customer to our field technicians consistently',
                    'We can deliver some of this data to our field technicians, but not consistently for every event or customer',
                    'We can usually deliver this data to our field technicians, but accuracy can be an issue',
                    'We can consistently deliver this data accurately to our field technicians',
                ],
                German: [
                    'German A ',
                    'German B',
                    'German C',
                    'German D ',
                ],
                French: [
                    'French A',
                    'French B',
                    'French C',
                    'French D',
                ],
                Russian: [
                    'Russian A',
                    'Russian B',
                    'Russian C',
                    'Russian D',
                ],
                Turkish: [
                    'Turkish A',
                    'Turkish B',
                    'Turkish C',
                    'Turkish D',
                ],
                Italian: [
                    'Italian A',
                    'Italian B',
                    'Italian C',
                    'Italian D',
                ],
                Spanish: [
                    'Spanish A',
                    'Spanish B',
                    'Spanish C',
                    'Spanish D',
                ],
                PortugueseBR: [
                    'PortugueseBR A',
                    'PortugueseBR B',
                    'PortugueseBR C',
                    'PortugueseBR C ',
                ],
                SpanishLAD: [
                    'SpanishLAD A',
                    'SpanishLAD B. ',
                    'SpanishLAD C',
                    'SpanishLAD D',
                ]
            },
            custVals: [25, 50,75, 100],
        }),
    new QuestionObj({
        questionSet:{
            English: 'Can you automate and optimize the scheduling and routing of any type of work, including urgent and emergency work, with no need for human intervention?',
            German: 'German Q2',
            French: "French Q2",
            Russian: "Russian Q2",
            Turkish: "Turkish Q2",
            Italian: "Italian Q2",
            Spanish: "Spanish Q2",
            PortugueseBR: "PortugueseBR Q2",
            SpanishLAD: "SpanishLAD Q2",
        },
        answerSet:{
            English: [
                'No, service activity scheduling is always done manually',
                'No, only some activities are scheduled automatically, and routing is not optimized',
                'No, most activities are scheduled automatically but there are work types that cannot be scheduled or optimized',
                'Yes, we can schedule and optimize routing of all service activities '
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100],
    }),
    new QuestionObj({
                questionSet: {
                    English: 'Do your field service teams have access to knowledge articles and guides on their mobile device?',
                    German: 'German Q3',
                    French: "French Q3",
                    Russian: "Russian Q3",
                    Turkish: "Turkish Q3",
                    Italian: "Italian Q3",
                    Spanish: "Spanish Q3",
                    PortugueseBR: "PortugueseBR Q3",
                    SpanishLAD: "SpanishLAD Q3",
                },

                answerSet: {
                    English: [
                        'No, our teams must carry physical documents with this information',
                        'Our teams have some digital access primarily through our public-facing website',
                        'Our teams can access this information, but may need to switch between multiple portals or applications to find it',
                        'This information is seamlessly integrated into and surfaced by the same field service application used to manage service events',                        
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
                },
                custVals: [25, 50, 75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can your field teams use guided repair flows and video collaboration to get expert support?',
            German: 'German Q4',
            French: "French Q4",
            Russian: "Russian Q4",
            Turkish: "Turkish Q4",
            Italian: "Italian Q4",
            Spanish: "Spanish Q4",
            PortugueseBR: "PortugueseBR Q4",
            SpanishLAD: "SpanishLAD Q4",
        },
        answerSet:{
            English: [
                'No, we do not have this capability',
                'Yes, but only outside of our systems with their personal mobile devices',
                'Yes, but only when service team members are available or not on other jobs',
                'Yes, we have a team dedicated to helping service technicians resolve unusual or complex issues through video and guided repair solutions',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75,100],
    }),
  new QuestionObj({
        questionSet:{
            English: 'Do you support a Bring Your Own Device (BYOD) environment where field service teams can use any device to access job details and perform work?',
            German: 'German Q5',
            French: "French Q5",
            Russian: "Russian Q5",
            Turkish: "Turkish Q5",
            Italian: "Italian Q5",
            Spanish: "Spanish Q5",
            PortugueseBR: "PortugueseBR Q5",
            SpanishLAD: "SpanishLAD Q5",
        },
        answerSet:{
            English: [
                'No, we do not have this capability',
                'No, our teams must use the device we issue them exclusively',
                'Yes, but we require certain tasks to be managed on the device we issue our field teams',
                'Yes, our teams can use the device of their choice for their day-to-day work',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50,75,100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can your customers track their on-site service events to see who is coming and when they will arrive?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                'No, we do not offer this capability to customers',
                'Customers receive reminders via email or text, but have no visibility in real-time regarding who is coming and when',
                'Customers receive reminders via email or text that include updated arrival times and information about the technician coming',
                'Customers can track their service technician in real-time using an "Uber-like" view on their computer or mobile device',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50,75, 100],
    }),
    new QuestionObj({
    questionSet:{
        English: 'How would you rate your ability to manage unplanned or emergency service events?',
        German: 'German Q1',
        French: "French Q1",
        Russian: "Russian Q1",
        Turkish: "Turkish Q1",
        Italian: "Italian Q1",
        Spanish: "Spanish Q1",
        PortugueseBR: "PortugueseBR Q1",
        SpanishLAD: "SpanishLAD Q1",
        },
        answerSet:{
            English: [
                'Unplanned or emergency events always disrupt daily schedules, add overtime, and impact customers',
                'We can manually adjust schedules, but not without some tradeoff for added overtime or customer impact',
                'We can usually adjust schedules without impacting schedules or adding overtime',
                'Our schedules automatically adjust to accommodate unplanned events without disrupting schedules',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Are you able to monitor and track route compliance, worker safety protocols, and other regulatory requirements?',
            German: 'German Q6',
            French: "French Q6",
            Russian: "Russian Q6",
            Turkish: "Turkish Q6",
            Italian: "Italian Q6",
            Spanish: "Spanish Q6",
            PortugueseBR: "PortugueseBR Q6",
            SpanishLAD: "SpanishLAD Q6",
        },
        answerSet:{
            English: [
                'No, we do not have this capability',
                'We have only limited tracking of regulatory and compliance details',
                'We have some regulatory and compliance tracking',
                'We have full visibility and tracking of regulatory and compliance details',
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50,75, 100],
    }),
    
];

export default FieldService_QSet;